import { render, staticRenderFns } from "./UsersGroupMosaicView.vue?vue&type=template&id=afbc400c&"
import script from "./UsersGroupMosaicView.vue?vue&type=script&lang=ts&"
export * from "./UsersGroupMosaicView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports